
<div class="component-wrapper">
    <form [formGroup]="institutionForm">
        <div class="fields-wrapper">
            <kendo-formfield class="name">
                <kendo-label class="form-label" [for]="name" text="{{'institution.organisation.name' | translate}} *" [infotooltip]="'institution.organisationsname'"></kendo-label>
                <kendo-textbox
                    #name
                    formControlName="name"
                    showSuccessIcon="initial"
                    showErrorIcon="initial"
                    appinfotext="institution.organisationsname"
                    preventEmptyFormatter
                    [maxlength]=100
                 ></kendo-textbox>
            </kendo-formfield>
            <kendo-formfield class="rechtsform">
                <kendo-label class="form-label" [for]="rechtsform" text="{{'institution.organisation.legalForm' | translate}} *" [infotooltip]="'institution.rechtsform'"></kendo-label>
                <kendo-combobox formControlName="rechtsform" [valuePrimitive]="true" #rechtsform [allowCustom]="false" 
                [data]="rechtsformList"
                [valueField]="'Value'"
                [appinfotext]="'institution.rechtsform'"
                [textField]="'Description'"
                kendoDropDownFilter
                >
                </kendo-combobox>
            </kendo-formfield>
        </div>

        <address class="address" [form]="institutionForm.Address"></address>
    </form>
</div>